import React from 'react';
import type { RowType } from '@atlaskit/dynamic-table/types';
import UserCellDumb from '@atlassian/jira-common-directory-v2/src/components/user-cell/index.tsx';
import { KEY, LEAD, NAME } from '../../../common/constants.tsx';
import type {
	ProjectsList,
	ProjectTransformed,
	RefetchProjects,
	Status,
} from '../../../common/types.tsx';
import KeyCell from './cells/key/index.tsx';
import NameCell from './cells/name/index.tsx';
import TypeCell from './cells/type/index.tsx';
import { getColumnsByStatus } from './utils.tsx';

export default function getTableRows(
	data: ProjectsList,
	status: Status,
	refetchProjects: RefetchProjects,
): RowType[] {
	if (!data || !data.total) {
		return [];
	}

	return data.page.map(
		(project: ProjectTransformed): RowType => ({
			cells: [
				{
					content: <NameCell name={project.name} avatarUrl={project.avatarUrl} />,
					//  key is added to stop table from internally sorting data
					key: NAME,
				},
				{
					content: <KeyCell value={project.key} />,
					key: KEY,
				},
				{
					content: <TypeCell simplified={project.simplified} typeKey={project.typeKey} />,
				},
				{
					content: <UserCellDumb user={project.user} />,
					key: LEAD,
				},
				...getColumnsByStatus(status, project, refetchProjects),
			],
		}),
	);
}
